import { useState, useEffect } from 'react';

// Hook ini menunda eksekusi pencarian sampai pengguna berhenti mengetik
const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        // Membersihkan timeout jika value berubah (misal: pengguna mengetik lagi)
        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);
    return debouncedValue;
};

export default useDebounce;